<div class="container" *ngIf="(requestHistory$ | async)?.length > 0" role="region" aria-label="Comment History">
  <div class="row">
    <div class="col-md-12">
      <h4 id="comment-history-heading">Comment History - {{package.packageNumber}}</h4>
      <table class="table table-striped" aria-labelledby="comment-history-heading">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">User</th>
            <th scope="col">Type</th>
            <th scope="col">Comment</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let request of requestHistory$ | async">
            <td>{{ request.requestedDate | date: 'medium' }}</td>
            <td>{{ request.requestedBy }}</td>
            <td>{{ request.requestType }}</td>
            <td>{{ request.comment }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>